import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import Icon from "../components/Icons";
import styles from "./BlogPage.module.css";
import useBlogPosts from "../hooks/useBlogPosts";
import useSiteSettings from "../hooks/useSiteSettings";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

export default function BlogPage() {
  const { posts, loading, hasPosts } = useBlogPosts();
  const { doctor } = useSiteSettings();

  return (
    <>
      <PageHeader
        eyebrow="Health insights"
        title="Notes on pain, movement and recovery."
        lead="Plain explanations of the things patients ask about most."
      />

      <section className={`u-section ${styles.section}`}>
        <div className="u-shell">
          {loading ? (
            <p className={styles.loading}>Loading articles…</p>
          ) : !hasPosts ? (
            <div className={styles.empty}>
              <span className={styles.emptyIcon}>
                <Icon name="posture" size={28} />
              </span>
              <h2 className={styles.emptyTitle}>Nothing published yet.</h2>
              <p className={styles.emptyText}>
                Articles are on the way. In the meantime, if you have a question
                about your pain or recovery, ask it directly — I answer these
                myself.
              </p>
              <a
                href={`https://wa.me/${doctor.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.emptyCta}
              >
                <Icon name="whatsapp" size={18} />
                Ask a question
              </a>
            </div>
          ) : (
            <ul className={styles.list}>
              {posts.map((post, i) => (
                <Reveal
                  as="li"
                  key={post.id}
                  delay={Math.min(i, 5) * 70}
                  className={styles.item}
                >
                  <Link to={`/blog/${post.id}`} className={styles.card}>
                    <div className={styles.cardMeta}>
                      <time dateTime={post.date}>{formatDate(post.date)}</time>
                      {post.readingMinutes && (
                        <span>{post.readingMinutes} min read</span>
                      )}
                    </div>
                    <h2 className={styles.cardTitle}>{post.title}</h2>
                    <p className={styles.cardExcerpt}>{post.excerpt}</p>
                    <span className={styles.cardMore}>
                      Read <Icon name="arrow" size={16} />
                    </span>
                  </Link>
                </Reveal>
              ))}
            </ul>
          )}
        </div>
      </section>
    </>
  );
}
